import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

const useEmailNotificationDrawer = ({
  resourceId,
  storeId,
  timeline,
  getPreviewService,
  resendService,
  refetchTimeline,
}) => {
  const { t } = useTranslation()
  const { setToastInfo } = useContext(ToastContext)
  const [selectedEmailNotification, setSelectedEmailNotification] = useState(null)

  const {
    data: emailNotificationPreview,
    loading: fetchingEmailNotificationPreview,
    fetchData: fetchEmailNotificationPreview,
  } = useFetch(getPreviewService, { doInitialRequest: false })

  const { fetchData: resendEmailNotification, loading: resendingEmailNotification } = useFetch(resendService, {
    doInitialRequest: false,
  })

  const openEmailNotificationDrawer = ({ id }) => {
    const notification = timeline?.find(event => event?.properties?.id === id)
    setSelectedEmailNotification(notification)
  }

  const closeEmailNotificationDrawer = () => {
    setSelectedEmailNotification(null)
  }

  useEffect(() => {
    if (!selectedEmailNotification || !resourceId) return
    fetchEmailNotificationPreview({
      resourceId,
      storeId,
      notificationId: selectedEmailNotification.properties.id,
    })
  }, [selectedEmailNotification, resourceId, storeId, fetchEmailNotificationPreview])

  const handleResendEmailNotification = async () => {
    try {
      await resendEmailNotification({
        resourceId,
        storeId,
        notificationId: selectedEmailNotification.properties.id,
      })
      closeEmailNotificationDrawer()
      refetchTimeline()
      setToastInfo({ show: true, message: t('Email reenviado'), type: 'success' })
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showEmailNotificationDrawer: !!selectedEmailNotification,
    selectedEmailNotification,
    openEmailNotificationDrawer,
    closeEmailNotificationDrawer,
    emailNotificationPreview,
    fetchingEmailNotificationPreview,
    handleResendEmailNotification,
    resendingEmailNotification,
  }
}

export default useEmailNotificationDrawer
